import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';

export default function Privacy() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-lp-bg">
      <Navbar />
      
      <div className="pt-20 px-4 pb-8">
        {/* Header */}
        <div className="mb-6">
          <button 
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-sepia-600 hover:text-sepia-800 font-ui text-sm mb-4 transition-colors duration-200"
          >
            <i className="ri-arrow-left-line"></i>
            Volver al inicio
          </button>
          
          <div className="vintage-paper aged-paper p-6 shadow-lg">
            <h1 className="font-headings text-2xl text-sepia-900 mb-2">POLÍTICA DE PRIVACIDAD</h1>
            <p className="text-sm text-sepia-600 font-ui">
              Última actualización: Enero 2024
            </p>
          </div>
        </div>

        {/* Content */}
        <div className="space-y-6">
          {/* Introduction */}
          <div className="vintage-paper aged-paper p-6 shadow-lg">
            <h2 className="font-headings text-lg text-sepia-900 mb-4">INTRODUCCIÓN</h2>
            <p className="text-sm text-sepia-700 font-body leading-relaxed mb-4">
              En Vintage Literal valoramos y respetamos tu privacidad. Esta política describe cómo recopilamos, 
              utilizamos y protegemos tu información personal cuando utilizas nuestro sitio web y servicios.
            </p>
            <p className="text-sm text-sepia-700 font-body leading-relaxed">
              Al utilizar nuestros servicios, aceptas las prácticas descritas en esta política de privacidad.
            </p>
          </div>

          {/* Information Collection */}
          <div className="vintage-paper aged-paper p-6 shadow-lg">
            <h2 className="font-headings text-lg text-sepia-900 mb-4">INFORMACIÓN QUE RECOPILAMOS</h2>
            
            <div className="space-y-4">
              <div>
                <h3 className="font-ui text-base text-sepia-800 mb-2">Información Personal</h3>
                <ul className="text-sm text-sepia-700 font-body leading-relaxed space-y-1 ml-4">
                  <li>• Nombre completo y dirección de correo electrónico al registrarte</li>
                  <li>• Contenido que publicas (artículos, comentarios)</li>
                  <li>• Información de perfil opcional</li>
                </ul>
              </div>

              <div>
                <h3 className="font-ui text-base text-sepia-800 mb-2">Información Técnica</h3>
                <ul className="text-sm text-sepia-700 font-body leading-relaxed space-y-1 ml-4">
                  <li>• Dirección IP y datos de ubicación general</li>
                  <li>• Tipo de navegador y dispositivo</li>
                  <li>• Páginas visitadas y tiempo de navegación</li>
                  <li>• Cookies y tecnologías similares</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Usage */}
          <div className="vintage-paper aged-paper p-6 shadow-lg">
            <h2 className="font-headings text-lg text-sepia-900 mb-4">CÓMO UTILIZAMOS TU INFORMACIÓN</h2>
            <ul className="text-sm text-sepia-700 font-body leading-relaxed space-y-2 ml-4">
              <li>• <strong>Proveer servicios:</strong> Gestionar tu cuenta y permitir la publicación de contenido</li>
              <li>• <strong>Comunicación:</strong> Enviarte notificaciones importantes sobre tu cuenta</li>
              <li>• <strong>Mejoras:</strong> Analizar el uso del sitio para mejorar nuestros servicios</li>
              <li>• <strong>Seguridad:</strong> Proteger contra fraudes y actividades maliciosas</li>
              <li>• <strong>Legal:</strong> Cumplir con obligaciones legales aplicables</li>
            </ul>
          </div>

          {/* Data Protection */}
          <div className="vintage-paper aged-paper p-6 shadow-lg">
            <h2 className="font-headings text-lg text-sepia-900 mb-4">PROTECCIÓN DE DATOS</h2>
            <div className="space-y-4">
              <p className="text-sm text-sepia-700 font-body leading-relaxed">
                Implementamos medidas de seguridad técnicas y organizativas apropiadas para proteger 
                tu información personal contra acceso no autorizado, alteración, divulgación o destrucción.
              </p>
              
              <div className="vintage-paper-subtle p-4 rounded-[10%] border-l-4 border-sepia-400">
                <h3 className="font-ui text-base text-sepia-800 mb-2">Medidas de Seguridad</h3>
                <ul className="text-sm text-sepia-700 font-body space-y-1 ml-4">
                  <li>• Encriptación de datos en tránsito y reposo</li>
                  <li>• Autenticación segura con Supabase</li>
                  <li>• Acceso limitado a información personal</li>
                  <li>• Monitoreo continuo de seguridad</li>
                </ul>
              </div>
            </div>
          </div>

          {/* User Rights */}
          <div className="vintage-paper aged-paper p-6 shadow-lg">
            <h2 className="font-headings text-lg text-sepia-900 mb-4">TUS DERECHOS</h2>
            <p className="text-sm text-sepia-700 font-body leading-relaxed mb-4">
              Tienes derecho a:
            </p>
            <ul className="text-sm text-sepia-700 font-body leading-relaxed space-y-2 ml-4">
              <li>• <strong>Acceso:</strong> Solicitar una copia de tu información personal</li>
              <li>• <strong>Rectificación:</strong> Corregir información inexacta o incompleta</li>
              <li>• <strong>Eliminación:</strong> Solicitar la eliminación de tu cuenta y datos</li>
              <li>• <strong>Portabilidad:</strong> Recibir tus datos en formato estructurado</li>
              <li>• <strong>Oposición:</strong> Oponerte al procesamiento de tus datos</li>
            </ul>
          </div>

          {/* Cookies */}
          <div className="vintage-paper aged-paper p-6 shadow-lg">
            <h2 className="font-headings text-lg text-sepia-900 mb-4">COOKIES Y TECNOLOGÍAS SIMILARES</h2>
            <p className="text-sm text-sepia-700 font-body leading-relaxed mb-4">
              Utilizamos cookies y tecnologías similares para mejorar tu experiencia, analizar el tráfico 
              y personalizar contenido. Puedes controlar las cookies a través de la configuración de tu navegador.
            </p>
            
            <div className="vintage-paper-subtle p-4 rounded-[10%]">
              <h3 className="font-ui text-base text-sepia-800 mb-2">Tipos de Cookies</h3>
              <ul className="text-sm text-sepia-700 font-body space-y-1 ml-4">
                <li>• <strong>Esenciales:</strong> Necesarias para el funcionamiento del sitio</li>
                <li>• <strong>Funcionales:</strong> Recuerdan tus preferencias y configuración</li>
                <li>• <strong>Analíticas:</strong> Nos ayudan a entender cómo usas el sitio</li>
              </ul>
            </div>
          </div>

          {/* Contact */}
          <div className="vintage-paper aged-paper p-6 shadow-lg">
            <h2 className="font-headings text-lg text-sepia-900 mb-4">CONTACTO</h2>
            <p className="text-sm text-sepia-700 font-body leading-relaxed mb-4">
              Si tienes preguntas sobre esta política de privacidad o quieres ejercer tus derechos, 
              puedes contactarnos:
            </p>
            
            <div className="vintage-paper-subtle p-4 rounded-[10%] text-center">
              <p className="text-sm text-sepia-800 font-ui mb-2">
                <i className="ri-mail-line mr-2"></i>
                <strong>Email:</strong> privacidad@vintageliteral.com
              </p>
              <p className="text-sm text-sepia-600 font-ui">
                Responderemos a tu solicitud dentro de 30 días hábiles
              </p>
            </div>
          </div>

          {/* Updates */}
          <div className="vintage-paper aged-paper p-6 shadow-lg">
            <h2 className="font-headings text-lg text-sepia-900 mb-4">ACTUALIZACIONES</h2>
            <p className="text-sm text-sepia-700 font-body leading-relaxed">
              Podemos actualizar esta política ocasionalmente. Te notificaremos sobre cambios 
              significativos publicando la nueva política en nuestro sitio web. El uso continuado 
              de nuestros servicios después de dichos cambios constituye tu aceptación de la nueva política.
            </p>
          </div>
        </div>

        {/* Vintage Background */}
        <div 
          className="fixed inset-0 pointer-events-none opacity-5 z-0"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=vintage%20legal%20office%2C%20antique%20wooden%20desk%20with%20legal%20documents%2C%20old%20law%20books%2C%20classic%20fountain%20pen%2C%20official%20seals%20and%20stamps%2C%20warm%20sepia%20lighting%2C%20formal%20atmosphere%2C%20aged%20parchment%20papers%2C%20brown%20and%20cream%20tones%2C%20scholarly%20legal%20setting%2C%20traditional%20lawyer%20office&width=375&height=812&seq=privacy_bg&orientation=portrait')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            mixBlendMode: 'multiply'
          }}
        />
      </div>
    </div>
  );
}